module.exports = __webpack_public_path__ + "assets/img/图片1.611f2b9e.png";